export const upgradeConst = {
    proIncludes: 'UPGRADE.PRO_INCLUDES',
    features: {
        default: {
            slogan: 'UPGRADE.DEFAULT_SLOGAN'
        },
        workspace: {
            slogan: 'UPGRADE.FEATURES.WORKSPACE.SLOGAN',
            title: 'UPGRADE.FEATURES.WORKSPACE.TITLE',
            description: 'UPGRADE.FEATURES.WORKSPACE.DESCRIPTION'
        },
        collaborator: {
            slogan: 'UPGRADE.FEATURES.COLLABORATOR.SLOGAN',
            title: 'UPGRADE.FEATURES.COLLABORATOR.TITLE',
            description: 'UPGRADE.FEATURES.COLLABORATOR.DESCRIPTION'
        },
        customDomain: {
            slogan: 'UPGRADE.FEATURES.CUSTOM_DOMAIN.SLOGAN',
            title: 'UPGRADE.FEATURES.CUSTOM_DOMAIN.TITLE',
            description: 'UPGRADE.FEATURES.CUSTOM_DOMAIN.DESCRIPTION'
        },
        unlimitedForms: {
            slogan: 'UPGRADE.FEATURES.UNLIMITED_FORMS.SLOGAN',
            title: 'UPGRADE.FEATURES.UNLIMITED_FORMS.TITLE',
            description: 'UPGRADE.FEATURES.UNLIMITED_FORMS.DESCRIPTION'
        }
    }
};
